export default () => {
  const { userAgent } = window.navigator;
  const userAgents = [
    'Android',
    '\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia',
  ];

  return userAgents.some((regexp) => new RegExp(regexp, 'i').test(userAgent));
};
